/** Compact chip rendering for tool_call/tool_result SSE events (docs/specs/app.md, chat view).
 * The tool name is a mono `.chip` — brass `.busy` while the call is in flight, plain once a
 * result has landed — with the args/result summary alongside in mono. */
export interface ToolActivity {
  kind: 'call' | 'result';
  name: string;
  text: string;
}

export function ToolChip({ activity }: { activity: ToolActivity }): JSX.Element {
  return (
    <span className="tool-act">
      <span className={`chip${activity.kind === 'call' ? ' busy' : ''}`}>{activity.name}</span>
      <span className="tool-act-text">{activity.text}</span>
    </span>
  );
}
